import { render, staticRenderFns } from "./SetupSchool.vue?vue&type=template&id=e281c8d2&scoped=true&"
import script from "./SetupSchool.vue?vue&type=script&lang=js&"
export * from "./SetupSchool.vue?vue&type=script&lang=js&"
import style0 from "./SetupSchool.vue?vue&type=style&index=0&id=e281c8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e281c8d2",
  null
  
)

export default component.exports